import React, { useEffect, useState } from 'react';
import { Typography, Grid, Card, CardContent, Box } from '@mui/material';
import LGD from '../../components/lgd';
import Ministry from '../../components/ministry';
import Event from '../../components/event';
import axios from 'axios';
import TableComponent from '../../components/table';
import { useSelector } from 'react-redux';
import { isNationalScopeRole } from '../../constants/roles';

const dataRow = {
  event_name: 'Event Name',
  event_count: 'Event Count',
};

const EventCreationReports = ({ setIsLoading, year }) => {
  const [selectedEventThemeCode, setSelectedEventThemeCode] = useState(undefined);
  const [selectedEventNameCode, setSelectedEventNameCode] = useState(undefined);
  const [selectedEventHeadingCode, setSelectedEventHeadingCode] = useState(undefined);
  const [selectedLocation, setSelectedLocation] = useState('');
  const [selectedStateCode, setSelectedStateCode] = useState(undefined);
  const [selectedDistrictCode, setSelectedDistrictCode] = useState(undefined);
  const [selectedBlockCode, setSelectedBlockCode] = useState(undefined);
  const [selectedGPCode, setSelectedGPCode] = useState(undefined);
  const [selectedVillageCode, setSelectedVillageCode] = useState(undefined);
  const [selectedULBCode, setSelectedULBCode] = useState(undefined);
  const [ministryCode, setMinistryCode] = useState(undefined);
  const [ministryDepartmentCode, setMinistryDepartmentCode] = useState(undefined);
  const [ministrySubUnitCode, setMinistrySubUnitCode] = useState(undefined);
  const [tableData, setTableData] = useState([]);
  const role = useSelector((state) => state.RoleReducer);

  const getReports = async () => {
    setIsLoading(true);
    setTableData([]);
    const baseUrl =
      'https://asia-south1-dashakswachhataka.cloudfunctions.net/getReportsLatest?resource=events&fields=["*","event_name"]&clickhouse_fields=["*","event_name"]&labels=["event_count"]&modifiers=["count"]&rank_by=event_count&categories=["event_name"]';

    let filters = [];

    if (selectedEventThemeCode) {
      filters.push(`event_theme_id='${selectedEventThemeCode}'`);
    }

    if (selectedEventHeadingCode) {
      filters.push(`event_heading_id='${selectedEventHeadingCode}'`);
    }

    if (selectedLocation) {
      filters.push(`location_type='${selectedLocation}'`);
    }

    if (selectedStateCode) {
      filters.push(`state_code='${selectedStateCode}'`);
    }

    if (selectedDistrictCode) {
      filters.push(`district_code='${selectedDistrictCode}'`);
    }

    if (selectedBlockCode) {
      filters.push(`block_code='${selectedBlockCode}'`);
    }

    if (selectedULBCode) {
      filters.push(`ulb_code='${selectedULBCode}'`);
    }

    if (selectedGPCode) {
      filters.push(`gp_code='${selectedGPCode}'`);
    }

    if (selectedVillageCode) {
      filters.push(`village_code='${selectedVillageCode}'`);
    }

    if (ministryCode) {
      filters.push(`ministry_code='${ministryCode}'`);
    }

    if (ministryDepartmentCode) {
      filters.push(`ministry_department_code='${ministryDepartmentCode}'`);
    }

    if (ministrySubUnitCode) {
      filters.push(`ministry_unit_code='${ministrySubUnitCode}'`);
    }

    const query =
      filters.length > 0
        ? `${baseUrl}&filters=[${filters.map((f) => `"${f}"`).join(',')}]`
        : baseUrl;

    try {
      // const url = `getCachedResultV1?url=${encodeURIComponent(query)}`;
      // console.log('url', url)
      const response = await axios.get(query);
      if (response.data) {
        setTableData(response.data);
      } else {
        setTableData([]);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching reports:', error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!role?.info?.role_id || isNationalScopeRole(role?.info?.role_id)) {
      getReports();
    }
    if (role?.info?.role_id === 2 && ministryCode) {
      getReports();
    }
    if (role?.info?.role_id === 3 && ministryDepartmentCode) {
      getReports();
    }
    if (role?.info?.role_id === 4 && ministrySubUnitCode) {
      getReports();
    }
    if (role?.info?.role_id === 5 && selectedStateCode) {
      getReports();
    }
    if (role?.info?.role_id === 6 && selectedDistrictCode) {
      getReports();
    }
    if (role?.info?.role_id === 7 && selectedULBCode) {
      getReports();
    }
    if (role?.info?.role_id === 8 && selectedBlockCode) {
      getReports();
    }
    if (role?.info?.role_id === 13 && ministryCode) {
      getReports();
    }
  }, [
    selectedEventThemeCode,
    selectedEventHeadingCode,
    selectedEventNameCode,
    selectedLocation,
    selectedStateCode,
    selectedDistrictCode,
    selectedBlockCode,
    selectedULBCode,
    selectedGPCode,
    selectedVillageCode,
    ministryCode,
    ministryDepartmentCode,
    ministrySubUnitCode,
    role,
  ]);

  return (
    <Grid container spacing={2} mb={2} mt={2}>
      <Event
        selectedEventThemeCode={selectedEventThemeCode}
        setSelectedEventThemeCode={setSelectedEventThemeCode}
        selectedEventNameCode={selectedEventNameCode}
        setSelectedEventNameCode={setSelectedEventNameCode}
        selectedEventHeadingCode={selectedEventHeadingCode}
        setSelectedEventHeadingCode={setSelectedEventHeadingCode}
      />
      {role?.info?.role_id !== 13 && (
        <LGD
          eventYear={year}
          selectedLocation={selectedLocation}
          setSelectedLocation={setSelectedLocation}
          selectedStateCode={selectedStateCode}
          setSelectedStateCode={setSelectedStateCode}
          selectedDistrictCode={selectedDistrictCode}
          setSelectedDistrictCode={setSelectedDistrictCode}
          selectedBlockCode={selectedBlockCode}
          setSelectedBlockCode={setSelectedBlockCode}
          selectedULBCode={selectedULBCode}
          setSelectedULBCode={setSelectedULBCode}
          selectedGPCode={selectedGPCode}
          setSelectedGPCode={setSelectedGPCode}
          selectedVillageCode={selectedVillageCode}
          setSelectedVillageCode={setSelectedVillageCode}
        />
      )}
      <Ministry
        ministryCode={ministryCode}
        setMinistryCode={setMinistryCode}
        ministryDepartmentCode={ministryDepartmentCode}
        setMinistryDepartmentCode={setMinistryDepartmentCode}
        ministrySubUnitCode={ministrySubUnitCode}
        setMinistrySubUnitCode={setMinistrySubUnitCode}
      />
      <Card sx={{ width: '100%' }}>
        <CardContent>
          <Box
            sx={{
              width: '100%',
              overflowX: 'auto',
            }}
          >
            {tableData?.length > 0 ? (
              <TableComponent data={tableData} mainHeaders={dataRow} fileName={'reports'} />
            ) : (
              <Typography variant="h3">No data yet</Typography>
            )}
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default EventCreationReports;
